import { NumberParam, StringParam, useQueryParams } from 'use-query-params'

import { GetLogisticFilialsParams } from 'redux/services/logistic-filial/types'

import { LogisticFilialStatus } from 'models/logistic-filial'

export const useLogisticFilialsFilters = () => {
  const [query, setQuery] = useQueryParams(
    {
      limit: NumberParam,
      offset: NumberParam,
      search: StringParam,
      pan: StringParam,
      start_date: StringParam,
      end_date: StringParam,
      status: StringParam,
      branch: StringParam,
    },
    {
      removeDefaultsFromUrl: true,
    },
  )

  const params: GetLogisticFilialsParams = {
    limit: Number(query.limit || 10),
    offset: Number(query.offset || 0),
    search: query.search || '',
    branch: query.branch || '',
    pan: query.pan || '',
    start_date: query.start_date || '',
    end_date: query.end_date || '',
    status: (query.status as LogisticFilialStatus) || undefined,
  }

  const resetParams = () => {
    setQuery({}, 'replace')
  }

  const setParam = (key: keyof GetLogisticFilialsParams, value: string) => {
    setQuery({
      [key]: value || undefined,
    })
  }

  const deleteParam = (key: keyof GetLogisticFilialsParams) => {
    setQuery({
      [key]: undefined,
    })
  }

  return {
    params,
    setParam,
    deleteParam,
    resetParams,
  }
}
